module.exports = __webpack_public_path__ + "img/Blackjack.833983ec.jpg";